import React from "react";
import { Modal } from "react-bootstrap";
import RoundBets from "../../../components/RoundBets";

/**
 * Casino result modal in the reference admin's markup (bootstrap-vue b-modal "casino-result", modal-xl):
 *   header.modal-header > h5.modal-title "{ename} Result" + button.close "×"
 *   .modal-body > div > .casino-result-round + {children}
 * Styled by the ported reference rules in styles/index.css.
 */
export default function RefResultModal({ show, onHide, title, roundId, matchTime, children, modalClass = "casino-result" }) {
  // Game pages open it with modal-class "casino-result"; the Casino Result Report opens it without
  return (
    <Modal show={show} onHide={onHide} className={modalClass || undefined} dialogClassName="modal-xl">
      <header className="modal-header">
        <h5 className="modal-title">{title}</h5>{" "}
        <button type="button" aria-label="Close" className="close" onClick={onHide}>
          ×
        </button>
      </header>
      <div className="modal-body">
        <div>
          <div className="casino-result-round">
            <div>Round-ID: {roundId}</div>{" "}
            <div>
              Match Time: <span>{matchTime}</span>
            </div>
          </div>{" "}
          {children}
          {/* the round's downline bets (hidden when there are none) */}
          <RoundBets show={show} roundId={roundId} />
        </div>{" "}
        <div />
      </div>
    </Modal>
  );
}
